module.exports = __webpack_public_path__ + "static/media/scheduled_pantry.5aee9816.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/scheduled_pantry.mp3
// module id = 403
// module chunks = 0